import { IApplicationState } from '../../types/redux';

export function getFullAddress(state: IApplicationState) {
  return state.newbuilding.fullAddress;
}
